import { z } from 'zod';
import { FINANCIAL_PRODUCT, LABELS } from '../constants';
import { requiredString, validateExpense } from '../helper';
import { generateSchema } from './helper';
import {
  amount,
  applicantMetadata,
  expense,
  householdIncome,
  householdIncomeWithDocuments,
  partnerIncome,
} from './model';

const { MARITAL_STATUS, DEPENDANTS } = LABELS;

// Define the raw shape of the default schema
const defaultSchema = {
  applicant: applicantMetadata.pick({ type: true }).merge(
    z.object({
      maritalStatus: requiredString(MARITAL_STATUS),
      dependents: requiredString(DEPENDANTS).default('0'),
      income: partnerIncome.optional(),
      expense: expense,
    }),
  ),
};

// Define the raw shape of the flex household schema
const flexHousehold = {
  applicant: applicantMetadata.pick({ type: true }).merge(
    z.object({
      maritalStatus: requiredString(MARITAL_STATUS),
      expense: z.object({
        mortgage: amount.superRefine((data, ctx) => validateExpense({ data, ctx })),
      }),
    }),
  ),
};

export const electrify2515HouseholdGeneric = {
  applicant: applicantMetadata.pick({ type: true }).merge(
    z.object({
      maritalStatus: requiredString(MARITAL_STATUS).optional(),
      dependents: requiredString(DEPENDANTS).default('0').optional(),
      income: householdIncome.and(partnerIncome).optional(),
      expense: expense.optional(),
    }),
  ),
};

export const electrify2515HouseholdCash = z.object({
  applicant: applicantMetadata.pick({ type: true }).merge(
    z.object({
      income: householdIncomeWithDocuments,
    }),
  ),
});

export const electrify2515HouseholdLoan = z.object({
  applicant: defaultSchema.applicant.merge(electrify2515HouseholdGeneric.applicant.pick({ income: true })),
});

const customSchemas = {
  [FINANCIAL_PRODUCT.FLEX]: flexHousehold,
  [FINANCIAL_PRODUCT.ELECTRIFY_2515]: electrify2515HouseholdGeneric,
};

// Pass the raw shape to the generateSchema function
export const householdSchema = generateSchema<typeof customSchemas, typeof defaultSchema>({
  customSchemas,
  defaultSchema: defaultSchema,
});
